import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useCallback } from "react";

import { Loader } from "components/customElements/loader";
import DiscussionSnippet from "components/DiscussionSnippet";
import EmptyState from "components/EmptyState";
import useInfiniteList from "hooks/useInfiniteList";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";
import { resourceDiscussionsInclude } from "consts/included";

const DiscussionModal = dynamic(() => import("components/DiscussionModal"));

type CollectionPageDiscussionsListProps = {};

export const collectionDiscussionsUrl = (slug: string, pageIndex: number) => {
  const url = new ApiEndpoint(`/api/v2/collections/${slug}/comment-threads`);
  url.searchParams.append("include", resourceDiscussionsInclude);
  url.searchParams.append("page[size]", "5");
  url.searchParams.append("page[number]", `${pageIndex}`);
  url.searchParams.append("sort", "-updated-at");

  return url.href;
};

export const fetcher = (endpoint: string) => {
  return baseFetcher(endpoint, undefined, {
    // comments: {
    //   valueForRelationship(relationship: { id: string }) {
    //     return {
    //       id: relationship.id,
    //     };
    //   },
    // },
  });
};

const CollectionPageDiscussionsList =
  ({}: CollectionPageDiscussionsListProps) => {
    const router = useRouter();
    const slug = router.query.slug as string;
    const itemId = router.query.discussion as string;

    const { infiniteList, mutate } = useInfiniteList(
      (pageIndex) => collectionDiscussionsUrl(slug, pageIndex + 1),
      {
        swrOptions: {
          revalidateOnMount: true,
          revalidateIfStale: true,
        },
        hasMore: ({ data }) =>
          !data?.length || !!data?.[data?.length - 1]?.data?.length,
        endIndicator: () => (
          <div className="text-center">No more discussion found</div>
        ),
        emptyIndicator: () => (
          <EmptyState
            type="discussion"
            onDiscussionPost={() => mutate()}
            showComposer={false}
          />
        ),
        loadingIndicator: () => <Loader numberOfItems={5} />,
        pageRender(pageData, _index) {
          if (!pageData) return null;

          return pageData?.data?.map?.((discussion: any) => (
            <DiscussionSnippet
              discussion={discussion}
              key={discussion.id}
              style={"compactV2"}
              showComposerByDefault
              noBorder
              hideReply
              onClick={() => {
                const parentId =
                  discussion?.["parent-id"] || discussion?.parent?.id;
                router.query.discussion = parentId || discussion?.id;
                router.push(router, undefined, {
                  shallow: true,
                  scroll: false,
                });
              }}
            />
          ));
        },
      }
    );

    const onCloseModal = useCallback(() => {
      const query = { ...router.query };
      delete query.discussion;

      router.replace({ query }, undefined, { shallow: true, scroll: false });
    }, [router]);

    return (
      <>
        <div className="">
          <div className="">{infiniteList}</div>
        </div>
        {itemId && (
          <DiscussionModal id={itemId} onClose={onCloseModal} style="v2" />
        )}
      </>
    );
  };

export default CollectionPageDiscussionsList;
